/* eslint-disable complexity */
// 9fbef606107a605d69c0edbcd8029e5d
/* eslint-disable sonarjs/cognitive-complexity */
import React from 'react';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import ClickTracker from '@tcp/web/src/components/common/atoms/ClickTracker';
import { PropTypes } from 'prop-types';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import ESGBadge from '@tcp/core/src/components/features/browse/ProductDetail/molecules/ESGBadge/';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import { PDP_SUB_LABELS, pdpSubLabels } from '@tcp/core/src/utils/labels/browse/PDP.labels';
import style from '../ProductDescription.style';
import { getLocator, getViewportInfo, isClient } from '../../../../../../../utils';
import {
  getMapSliceForColor,
  getMapColorList,
  getCurrentProductBadges,
} from '../../../../ProductListing/molecules/ProductList/utils/productsCommonUtils';
import getPrefixId from './ProductDescription.view.util';

class ProductDetailDescription extends React.PureComponent {
  pdpSubLabelsObj = getLabelFromCopyOrFromTranslation(PDP_SUB_LABELS, pdpSubLabels);

  constructor(props) {
    super(props);
    const showMore = typeof window !== 'undefined' ? !!props.isShowMore : false;
    this.state = {
      isShowMore: showMore,
      isExpanded: true,
      isAccordionOpen: false,
      hasMounted: false, // Used to solve image flickering issue
    };

    this.handleToggleShowMoreOrLess = this.handleToggleShowMoreOrLess.bind(this);
    this.handleAccordionToggle = this.handleAccordionToggle.bind(this);
  }

  componentDidMount() {
    this.setState({ hasMounted: true });
  }

  getButton = (isESGButton) => {
    const ShowMore = renderLabel(
      this.pdpSubLabelsObj.lbl_product_description_show_more,
      'lbl_product_description_show_more'
    );
    const ShowLess = renderLabel(
      this.pdpSubLabelsObj.lbl_product_description_show_less,
      'lbl_product_description_show_less'
    );
    const ViewMore = renderLabel(this.pdpSubLabelsObj.lbl_view_more, 'lbl_view_more');
    const ViewLess = renderLabel(this.pdpSubLabelsObj.lbl_view_less, 'lbl_view_less');
    let buttonShowMoreOrLess = null;
    const { productInfo, productId, isNewPDPEnabled } = this.props;
    const { isShowMore } = this.state;
    let generalProductId = '';
    let pageName = '';
    let pageShortName = '';
    const productName = productInfo && productInfo.name && productInfo.name.toLowerCase();
    if (productId) {
      [generalProductId] = productId.split('_');
      pageName = `product:${generalProductId}:${productName}`;
      pageShortName = pageName;
    }
    if (isShowMore) {
      buttonShowMoreOrLess = (
        <div className={`button-show-less${isESGButton ? ' flex-button-container' : ''}`}>
          <button
            className={`button-wrapper${isESGButton ? ' flex-button-wrapper' : ''}`}
            type="button"
            onClick={this.handleToggleShowMoreOrLess}
            data-locator={getLocator('pdp_read_less')}
          >
            {!isESGButton && isNewPDPEnabled ? ViewLess : ShowLess}
          </button>
        </div>
      );
    } else {
      buttonShowMoreOrLess = (
        <div className={`button-show-more${isESGButton ? ' flex-button-container' : ''}`}>
          <ClickTracker
            clickData={{
              pageShortName,
              pageName,
              pageType: 'product',
              pageSection: 'product',
              pageSubSection: 'product',
              pageNavigationText: '',
              products: [{ id: `${generalProductId}` }],
              customEvents: ['event119'],
            }}
          >
            <button
              className={`button-wrapper${isESGButton ? ' flex-button-wrapper' : ''}`}
              type="button"
              role="link"
              onClick={this.handleToggleShowMoreOrLess}
              data-locator={getLocator('pdp_read_more')}
            >
              {!isESGButton && isNewPDPEnabled ? ViewMore : ShowMore}
            </button>
          </ClickTracker>
        </div>
      );
    }
    return buttonShowMoreOrLess;
  };

  getDescAvailable = (shortDescription, longDescription) => {
    return shortDescription || longDescription;
  };

  getAccordionClass = (isAccordionOpen) => {
    return isAccordionOpen ? 'show-accordion-toggle' : '';
  };

  getClaimMessageClass = (descAvail) => {
    return !descAvail ? 'common-claim-message' : '';
  };

  getFlexContainerClass = (pdpTabview) => {
    return pdpTabview ? 'flex-container' : '';
  };

  getShowMoreClass = (isShowMore) => {
    return isShowMore ? 'show-more-expanded' : '';
  };

  pdpTabsDescriptionClass = (pdpTabview) => {
    return pdpTabview ? 'pdp-tabs-view-description' : '';
  };

  pdpTabsViewClass = (pdpTabview) => {
    return pdpTabview ? 'pdp-tabs-description' : '';
  };

  getIsMobile() {
    return isClient() ? getViewportInfo().isMobile : null;
  }

  itemLists = (colorName) => {
    return <li key={colorName}>{colorName}</li>;
  };

  getLongDescription = ({ colorDisplayId, isBundleProduct, allProductId, longDescription }) => {
    if (!isBundleProduct) {
      const currentLongDescription = allProductId?.find(
        (product) => product.productid === colorDisplayId
      )?.style_long_description;

      if (currentLongDescription) {
        return currentLongDescription;
      }
    }
    return longDescription;
  };

  getShortDescription = ({ colorDisplayId, isBundleProduct, allProductId, shortDescription }) => {
    if (!isBundleProduct) {
      const currentShortDescription = allProductId?.find(
        (product) => product.productid === colorDisplayId
      )?.product_short_description;

      if (currentShortDescription) {
        return currentShortDescription;
      }
    }
    return shortDescription;
  };

  getProductBadges = ({
    colorDisplayId,
    isESGBadgePDPBackABEnabled,
    isBundleProduct,
    allProductId,
  }) => {
    if (isESGBadgePDPBackABEnabled) {
      return null;
    }

    return isBundleProduct
      ? ''
      : getCurrentProductBadges({
          backAB: isESGBadgePDPBackABEnabled,
          allProductId,
          colorDisplayId,
        });
  };

  shouldRenderESGBadges({ pdpTabview, productBadges }) {
    return (pdpTabview && productBadges) || false;
  }

  shouldRenderShowMoreOrLessButton({ descAvail, isESGBadgePDPBackABEnabled, pdpTabview }) {
    return (!isESGBadgePDPBackABEnabled && descAvail && pdpTabview) || false;
  }

  handleAccordionToggle() {
    const { isAccordionOpen } = this.state;
    this.setState({ isAccordionOpen: !isAccordionOpen });
  }

  handleToggleShowMoreOrLess() {
    const { isShowMore } = this.state;
    this.setState({
      isShowMore: !isShowMore,
    });
  }

  shouldRenderClaimMessageOnPDPTabViewMobile({ pdpTabview }) {
    return pdpTabview;
  }

  renderClaimMessage({ claimMessageClass }) {
    const ClaimMessage = renderLabel(
      this.pdpSubLabelsObj.lbl_product_description_claim_message,
      'lbl_product_description_claim_message'
    );
    return (
      <BodyCopy
        className={`claim-message ${claimMessageClass}`}
        component="aside"
        fontSize="fs14"
        fontFamily="secondary"
        data-locator={getLocator('pdp_claim_message')}
      >
        {ClaimMessage}
      </BodyCopy>
    );
  }

  renderPartNo({ descAvail, isNewPJPPDPRedesignEnabled, getButton, productItemId }) {
    return (
      <>
        {descAvail && (
          <div className="product-detail-footer">
            {!isNewPJPPDPRedesignEnabled && getButton}
            <BodyCopy
              component="span"
              className="show-product-id"
              fontSize="fs10"
              fontFamily="secondary"
              data-locator={getLocator('pdp_product_part_number')}
            >
              {productItemId}
            </BodyCopy>
          </div>
        )}
        {!descAvail && (
          <BodyCopy
            className="part-number-section"
            fontSize="fs10"
            fontFamily="secondary"
            data-locator={getLocator('pdp_product_part_number')}
          >
            {productItemId}
          </BodyCopy>
        )}
      </>
    );
  }

  render() {
    const productIncludeText = renderLabel(
      this.pdpSubLabelsObj.lbl_product_include_text,
      'lbl_product_include_text'
    );
    const ProductDescription = renderLabel(
      this.pdpSubLabelsObj.lbl_product_description_label,
      'lbl_product_description_label'
    );
    const KeyFeatures = renderLabel(this.pdpSubLabelsObj.lbl_key_features, 'lbl_key_features');
    const PartNumber = renderLabel(
      this.pdpSubLabelsObj.lbl_product_description_item_part_number,
      'lbl_product_description_item_part_number'
    );
    const {
      longDescription,
      shortDescription,
      className,
      color,
      TCPStyleColor,
      isNewPDPEnabled,
      pdpTabview,
      isBundleProduct,
      isESGBadgePDPBackABEnabled,
      variantNumber,
    } = this.props;
    const {
      productInfo: { colorFitsSizesMap, getMultiPackAllColor, allProductId },
      isNewPJPPDPRedesignEnabled,
    } = this.props;
    const { isExpanded, isAccordionOpen, isShowMore, hasMounted } = this.state;
    const colorSlice = getMapSliceForColor(colorFitsSizesMap, color);
    const colorDisplayId = colorSlice && colorSlice.colorDisplayId;
    const currentShortDescription = this.getShortDescription({
      colorDisplayId,
      isBundleProduct,
      allProductId,
      shortDescription,
    });
    const currentLongDescription = this.getLongDescription({
      colorDisplayId,
      isBundleProduct,
      allProductId,
      longDescription,
    });
    const descAvail = this.getDescAvailable(currentShortDescription, currentLongDescription);
    const getButton = this.getButton();
    const accordionToggleClass = this.getAccordionClass(isAccordionOpen);
    const claimMessageClass = this.getClaimMessageClass(!!descAvail);
    const flexContainerClass = this.getFlexContainerClass(pdpTabview);
    const showMoreClass = this.getShowMoreClass(isShowMore);
    const productBadges = this.getProductBadges({
      isESGBadgePDPBackABEnabled,
      colorDisplayId,
      isBundleProduct,
      allProductId,
    });
    const prefixId = getPrefixId(getMultiPackAllColor, colorDisplayId, PartNumber);
    const productItemId = `${prefixId} ${colorDisplayId}${
      variantNumber ? `#${variantNumber}` : ''
    } `;
    const colorList = getMapColorList(TCPStyleColor, colorSlice);
    const renderClaimMessage = this.renderClaimMessage({ claimMessageClass });
    const renderPartNo = this.renderPartNo({
      descAvail,
      isNewPJPPDPRedesignEnabled,
      getButton,
      productItemId,
    });
    const shouldRenderClaimMessageOnPDPTabViewMobile =
      this.shouldRenderClaimMessageOnPDPTabViewMobile({ pdpTabview });
    const pdpTabsDescriptionClass = this.pdpTabsDescriptionClass(pdpTabview);
    const pdpTabsViewClass = this.pdpTabsViewClass(pdpTabview);

    return (
      <div
        id={'tab-structure-features'}
        aria-labelledby={'tab-features'}
        role="tabpanel"
        className={`${className} product-description-list ${pdpTabsDescriptionClass}`}
      >
        {!isNewPJPPDPRedesignEnabled && (
          <BodyCopy
            className={`product-desc-heading ${accordionToggleClass}${
              pdpTabview ? 'pdp-tabs-view-features' : ''
            }`}
            fontSize={isNewPDPEnabled ? 'fs16' : 'fs14'}
            component="div"
            fontFamily="secondary"
            fontWeight="black"
            onClick={pdpTabview ? '' : this.handleAccordionToggle}
            data-locator={getLocator('pdp_product_description_label')}
          >
            {isNewPDPEnabled ? KeyFeatures : ProductDescription}
          </BodyCopy>
        )}
        {isExpanded && (
          <>
            <div className={`${flexContainerClass} ${showMoreClass}`}>
              <div
                className={`${isAccordionOpen ? 'show-description-list' : ''} ${pdpTabsViewClass}`}
              >
                {currentShortDescription && (
                  <BodyCopy
                    className="short-description"
                    fontSize="fs14"
                    fontFamily="secondary"
                    data-locator={getLocator('pdp_short_description')}
                  >
                    {currentShortDescription}
                  </BodyCopy>
                )}
                <div
                  className={`introduction-text ${showMoreClass}`}
                  ref={(divElement) => {
                    this.divElement = divElement;
                  }}
                >
                  {currentLongDescription && (
                    <>
                      <BodyCopy
                        className="list-content"
                        component="ul"
                        dangerouslySetInnerHTML={{ __html: currentLongDescription }}
                        fontSize="fs14"
                        fontFamily="secondary"
                        data-locator={getLocator('pdp_long_description')}
                      />

                      {colorList && (
                        <BodyCopy component="div">
                          <BodyCopy
                            component="p"
                            fontSize="fs14"
                            fontFamily="secondary"
                            className="product-desc-heading"
                            fontWeight="black"
                            data-locator={getLocator('pdp_product_part_number')}
                          >
                            {productIncludeText}
                          </BodyCopy>
                          <BodyCopy
                            className="list-content"
                            component="ul"
                            fontSize="fs14"
                            fontFamily="secondary"
                          >
                            {colorList.map((colorName) => this.itemLists(colorName))}
                          </BodyCopy>
                        </BodyCopy>
                      )}
                    </>
                  )}
                  {shouldRenderClaimMessageOnPDPTabViewMobile && (
                    <div className="show-on-desktop"> {renderClaimMessage} </div>
                  )}
                </div>
                {shouldRenderClaimMessageOnPDPTabViewMobile && (
                  <div className="show-on-desktop"> {renderPartNo} </div>
                )}
              </div>
              {this.shouldRenderESGBadges({
                pdpTabview,
                productBadges,
              }) && <ESGBadge productBadges={productBadges} />}
              {shouldRenderClaimMessageOnPDPTabViewMobile && (
                <div className="show-on-mobile">
                  {renderClaimMessage}
                  {renderPartNo}
                </div>
              )}
            </div>
            {hasMounted &&
              this.shouldRenderShowMoreOrLessButton({
                descAvail,
                pdpTabview,
                isESGBadgePDPBackABEnabled,
              }) && (
                <div id="button" className="button show-on-mobile">
                  {this.getButton(true)}
                </div>
              )}
          </>
        )}
      </div>
    );
  }
}

ProductDetailDescription.propTypes = {
  className: PropTypes.string,
  productId: PropTypes.string,
  isShowMore: PropTypes.bool,
  longDescription: PropTypes.string,
  color: PropTypes.string,
  shortDescription: PropTypes.string,
  productInfo: PropTypes.shape({}),
  TCPStyleColor: PropTypes.string.isRequired,
  isNewPDPEnabled: PropTypes.bool,
  isNewPJPPDPRedesignEnabled: PropTypes.bool,
  isBundleProduct: PropTypes.bool,
  pdpTabview: PropTypes.bool,
  variantNumber: PropTypes.string,
};

ProductDetailDescription.defaultProps = {
  className: '',
  isShowMore: '',
  longDescription: '',
  productId: '',
  shortDescription: '',
  productInfo: {},
  color: '',
  isNewPDPEnabled: false,
  isNewPJPPDPRedesignEnabled: false,
  isBundleProduct: false,
  pdpTabview: false,
  variantNumber: null,
};

export default errorBoundary(withStyles(ProductDetailDescription, style));
export { ProductDetailDescription as ProductDetailDescriptionVanilla };
